export default __webpack_public_path__ + "static/media/p1-slice2-m.eb23eae5.png";